// extracted by mini-css-extract-plugin
export var container = "_fk-1";
export var cornerButtonContainer = "_fk-6";
export var disabled = "_fk-2";
export var dragActive = "_fk-3";
export var fileContainer = "_fk-5";
export var hiddenInput = "_fk-4";
export var widthContainer = "_fk-0";